import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import type { RespondFormWrapperConfig } from '@core/ask-hr-dynamic-forms-types';
import { TranslatePipe } from '@core/i18n-legacy';
import {
  BadgeComponent,
  DividerComponent,
  HeadingComponent,
  IconComponent,
} from '@core/user-interface-legacy';

@Component({
  selector: 'respond-form-wrapper',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './respond-form-wrapper.component.less',
  imports: [HeadingComponent, IconComponent, DividerComponent, BadgeComponent, TranslatePipe],
  template: `
    <div padding>
      <div layout layout-space-between>
        <rt-heading>{{ answerConfig().question }}</rt-heading>
        @if (!answerConfig().required) {
          <rt-badge color="secondary" [text]="'tlc.dynamic_form.define.optional' | translate" />
        }
      </div>
      @if (answerConfig().hint; as hint) {
        <div layout layout-align-items-center>
          <rt-icon name="info-outline" margin-right-small-xx />
          <span>{{ hint }}</span>
        </div>
      }
    </div>
    <rt-divider />
    <div padding>
      <ng-content />
    </div>
  `,
  host: {
    class: 'rt-card',
  },
})
export class RespondFormWrapperComponent {
  public answerConfig = input.required<RespondFormWrapperConfig>();
}
